import { getRecipient } from './getOutlookRecipient'
import gateway, { SIMPLE_EMAIL_REGEX } from '../gateway/gateway'
import { notify } from '../redux/notifications'
import { messages } from './messages'
import { getPersonByEmail } from '../services/people'
import { addBreadcrumb, captureException } from '../sentry-config'

export const setTemplate = template => ({
  type: 'SET_TEMPLATE',
  template,
})

export const assignTemplateWarnings = template => {
  const action = {
    type: 'ASSIGN_TEMPLATE_WARNINGS',
    warnings: { body: [], subject: [] },
  }

  if (!template) {
    return action
  }

  const tagRegex = /{{[^}]+}}/g
  const getWarnings = (string, pattern) => {
    if (!string) {
      return []
    }

    return string.match(pattern) || []
  }

  action.warnings.body = getWarnings(template.body, tagRegex)
  action.warnings.subject = getWarnings(template.subject, tagRegex)

  return action
}

export const getEmptyTemplate = templateId => dispatch => {
  addBreadcrumb({ message: 'Getting empty template', category: 'request' })
  return gateway.emailTemplates
    .show(templateId)
    .then(json => dispatch(setTemplate(json)))
    .catch(captureException)
}

export const getPopulatedTemplate = (templateId, email, subject, body) => dispatch => {
  const payload = {
    template_id: templateId,
    to: email,
    body,
    subject,
  }
  addBreadcrumb({ message: 'Getting populated template', category: 'request' })
  return gateway.emails
    .create(payload)
    .then(json => {
      if (!json) {
        captureException(
          new Error(
            'Failed to get template: recipients are either marked DNC or have email contact restrictions'
          )
        )
        dispatch(
          notify({
            type: 'error',
            message: messages.textNotifyRecipientsDNC,
          })
        )

        return
      }
      dispatch(setTemplate(json))
      dispatch(assignTemplateWarnings(json))
    })
    .catch(captureException)
}

const getRenderedTemplate = (templateId, email, currentUser) => dispatch => {
  addBreadcrumb({ message: 'Getting rendered template', category: 'request' })
  return getPersonByEmail(email, currentUser)
    .then(response => {
      if (Array.isArray(response) ? response.length === 0 : !response) {
        return dispatch(getEmptyTemplate(templateId))
      }
      return dispatch(getPopulatedTemplate(templateId, email, null, null))
    })
    .catch(e => {
      captureException(e)
      dispatch(
        notify({
          type: 'error',
          message: messages.textNotifyNoAccessToRecipients,
        })
      )
      throw e
    })
}

export const getEmailAndTemplate = templateId => (dispatch, getState) =>
  dispatch(getRecipient()).then(() => {
    const email = getState().templates.recipient
    if (email == null || !SIMPLE_EMAIL_REGEX.test(email)) {
      return dispatch(getEmptyTemplate(templateId))
    } else {
      addBreadcrumb({ message: 'Recipient', data: { email: JSON.stringify(email) } })
      return dispatch(getRenderedTemplate(templateId, email, getState().currentUser))
    }
  })
